// removed by extract-text-webpack-plugin
module.exports = {"tab":"Tab-module__tab___37jjd","title":"Tab-module__title___2cCd6","icon":"Tab-module__icon___2-SNm","selected":"Tab-module__selected___3RZjs","mobile":"Tab-module__mobile___zftxp"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/ShipmentTabs/Tab.module.scss
// module id = 262
// module chunks = 0 1